import { initSendbird } from './sendbird';

export default initSendbird;
